module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.2fe2efe6.svg";